<template>
  <div class="unsolicited-items">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        id="unsolicited-select"
        v-close-on-zoom
        :value="selected"
        :placeholder="placeholder"
        :filterable="true"
        :default-first-option="true"
        class="unsolicited-select"
        :disabled="readonly"
        @input="(unsolicitedId) => selectUnsolicited(unsolicitedId)"
      >
        <el-option
          v-for="unsolicitedItem in items"
          :key="unsolicitedItem.id"
          :label="unsolicitedItem.options.answer.en"
          :value="unsolicitedItem.id"
        />
      </el-select>
    </el-tooltip>
    <help-tooltip v-if="!selected" type="warning">
      An option must be selected. Data will not be saved.
    </help-tooltip>
    <help-tooltip v-if="errors.length" type="error">
      <span v-for="error in errors" :key="error.message">{{
        error.message
      }}</span>
    </help-tooltip>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'unsolicited-items',
  components: {
    HelpTooltip,
  },
  props: {
    emitter: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: null
    },
    control: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Unsolicited item'
    },
  },
  data() {
    return {
      state: {
        id: null,
      },
    };
  },
  computed: {
    selectedContent() {
      const item = this.items.find(i => i.id === this.state.id);
      return get(item, 'options.answer.en');
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        []
      ).filter((error) => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
  },
  methods: {
    selectUnsolicited(unsolicitedId) {
      this.state.id = unsolicitedId;
      this.update();
    },
    update() {
      this.$emit('update', this.state.id);
    },
  },
};
</script>

<style scoped>
</style>
